import { render, staticRenderFns } from "./ModalContentAddProperty.vue?vue&type=template&id=245d6163&scoped=true&"
import script from "./ModalContentAddProperty.vue?vue&type=script&lang=js&"
export * from "./ModalContentAddProperty.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentAddProperty.vue?vue&type=style&index=0&id=245d6163&lang=scss&scoped=true&"
import style1 from "./ModalContentAddProperty.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d6163",
  null
  
)

export default component.exports